import Body from "./body";

export default function Description() {
  return <Body />;
}
